(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Langdon",
                {
                    url: "/Langdon",
                    component: "e4llangdon",
                    PageTitle: "Elevate for Life - Crystal Langdon"
                });
        }
    ]);

    app.component("e4llangdon",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Langdon/Langdon.html",
            controller: e4LLangdonCtrl,
            bindings: {
            }
        });

    e4LLangdonCtrl.$inject = ["$timeout", "$state", "$mdDialog", "$filter", "wistiaApi", "permissionService"];

    function e4LLangdonCtrl($timeout, $state, $mdDialog, $filter, wistiaApi, permissionService) {
        var $ctrl = this;
        $ctrl.PageTitle = "Elevate for Life: Crystal Clear Finances";

        $ctrl.loadResources = function () {

            $ctrl.loadingAssets = true;
            wistiaApi.getElevateForLifeLangdonAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("orderBy")($filter("unique")(projectMedias, "section"), "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                        {
                            Title: value.section,
                            Active: uniqueMedias.length > 1 ? true : false,
                            Medias: ($filter("filter")(projectMedias, { section: value.section }))
                        }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);
        }      

        if (permissionService.hasOnePermission("ElevateForLife:Access")) {
            $ctrl.loadResources();
        }
    }



})(window.app, window.angular); // jshint ignore:line